import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import translate from 'i18n/translate';

const NavItem = ({ name, path, location }) => {
  return (
    <li
      data-toggle="collapse"
      data-target=".navbar-collapse.show"
      className={`nav-item ${location === path ? 'activeUrl' : ''}`}
    >
      <Link to={path} className="nav-link">
        {name}
      </Link>
    </li>
  );
};

const Navbar = () => {
  const location = useLocation();

  return (
    <nav className="navbar navbar-expand-sm navbar-dark center-container">
      <button
        className="navbar-toggler "
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav">
          <NavItem
            name={translate('home')}
            path="/"
            location={location.pathname}
          ></NavItem>
          {/* <NavItem name="Vesti" path="" location={location.pathname}></NavItem> */}
          <NavItem
            name={translate('aboutUs')}
            path="/about"
            location={location.pathname}
          ></NavItem>
          <NavItem
            name={translate('services')}
            path="/services"
            location={location.pathname}
          ></NavItem>
          <NavItem
            name={translate('structure')}
            path="/structure"
            location={location.pathname}
          ></NavItem>

          <div style={{ fontSize: '1.5rem' }} className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {translate('members')}
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <NavItem
                name={translate('ourMemebers')}
                path="/companies"
                location={location.pathname}
              ></NavItem>
              <NavItem
                name={translate('becomeMember')}
                path="/members"
                location={location.pathname}
              ></NavItem>
            </div>
          </div>

          <NavItem
            name={translate('projects')}
            path="/projects"
            location={location.pathname}
          ></NavItem>
          <NavItem
            name={translate('documents')}
            path="/documents"
            location={location.pathname}
          ></NavItem>
          <NavItem
            name={translate('media')}
            path="/media"
            location={location.pathname}
          ></NavItem>
          <NavItem
            name={translate('contact')}
            path="/contact"
            location={location.pathname}
          ></NavItem>
          {/* <NavItem
            name={translate('login')}
            path="/login"
            location={location.pathname}
          ></NavItem> */}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
